<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <!-- TODO: Translate -->
        <sidebar-item :link="{
                              name: 'Map',
                              path: '/map',
                              icon: 'ni ni-pin-3 text-orange'
                            }">
        </sidebar-item>
        <sidebar-item
            :link="{
              name: 'Trips',
              path: '/trips',
              icon: 'ni ni-compass-04 text-yellow'
              }">
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'GPS Devices',
            path: '/gps-devices',
            icon: 'ni ni-world-2 text-red'
          }">
        </sidebar-item>
        <sidebar-item :link="{
                        name: 'Checkpoints',
                        path: '/checkpoints',
                        icon: 'ni ni-active-40 text-blue'
                      }">
        </sidebar-item>
        <sidebar-item :link="{
                                name: 'Maintenance',
                                path: '/maintenance',
                                icon: 'ni ni-settings text-green'
                              }">
        </sidebar-item>
      </template>
      
      <template slot="links-after">
        <!-- <hr class="my-3"> -->
        <h6 class="navbar-heading p-0 text-muted">BETA</h6>
        
        <ul class="navbar-nav">
          <sidebar-item
              :link="{
                name: 'Motorbikes',
                path: '/motorbikes',
                icon: 'ni ni-key-25 text-orange'
              }">
          </sidebar-item>
        </ul>

        <hr class="my-3">
        <h6 class="navbar-heading p-0 text-muted">ALPHA</h6>
        <ul class="navbar-nav">
          <sidebar-item
            :link="{
              name: 'Home',
              path: '/dashboard',
              icon: 'ni ni-tv-2 text-primary',
            }"
          >
          </sidebar-item>
        </ul>

        <!-- <b-nav class="navbar-nav mb-md-3">
          <b-nav-item
               href="https://www.creative-tim.com/learning-lab/bootstrap-vue/quick-start/argon-dashboard"
               >
              <i class="ni ni-spaceship"></i>
              <b-nav-text class="p-0">Getting started</b-nav-text>
          </b-nav-item>
          <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/colors/argon-dashboard">
              <i class="ni ni-palette"></i>
              <b-nav-text class="p-0">Foundation</b-nav-text>
          </b-nav-item>
          <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/avatar/argon-dashboard">
              <i class="ni ni-ui-04"></i>
              <b-nav-text class="p-0">Components</b-nav-text>
          </b-nav-item>
        </b-nav> -->
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      }
    },
    mounted() {
      this.initScrollbar()
    }
  };
</script>
<style lang="scss">
</style>
